module.exports = __webpack_public_path__ + "ec6d4c08ceaa80ac85dbbddf2b98a6ce.jpg";